module.exports = __webpack_public_path__ + "img/google.916d0ae6.svg";